import { getActivePinia, storeToRefs, } from 'pinia'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'
import { useRoute, } from 'vue-router'
import { usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { useResourceListStore, } from '@/assets/js/src/modules/resource/_pinia/resourceList'
import { useResourceStore, } from '@/assets/js/src/modules/resource/_pinia/resource'
import { computed, onUnmounted, watch, } from 'vue'
import { useComponentIsActive, } from '@/assets/js/src/util/composables/useComponentIsActive'

export function useResourceListApi () {
    let activePinia = getActivePinia()
    let resourceListStore = useResourceListStore(activePinia)
    let resourceStore = useResourceStore(activePinia)
    let appUiStore = useAppUiStore(activePinia)
    let route = useRoute()
    
    let { resourceItems,reload, } = storeToRefs(resourceListStore)

    const provider = computed(()=>resourceStore.getSingleProviderName(route.params.provider))
    
    let { messagesLoaded,asyncStatus,updateData, } = usePrefetchData({
        actions: [
            {
                item: resourceItems,
                action: resourceListStore.getResourceItems,
                payload: function () {
                    return {
                        page: 1,
                        provider: provider.value,
                        query: route.query,
                    }
                },
            },
        ],
        loadAsyncMessages: [ 'resource', 'common', ],
    })

    let { componentIsActive, } = useComponentIsActive()
    watch(reload, async (newBoolean, oldBoolean) => {
        if (newBoolean && newBoolean !== oldBoolean && componentIsActive) {
            await updateData()
            resourceListStore.reload = false
        }
    })

    watch(provider, 
        async (newValue, oldValue) => {
            if (newValue !== oldValue && componentIsActive && appUiStore.countRouteChange > 1) {
                resourceListStore.$reset()
                await updateData(true)
            }
        },
        { immediate: !import.meta.env.SSR, })

    watch(()=>route.query,
        async (newValue, oldValue) => {
            if (newValue !== oldValue && Object.keys(newValue).length !== 0) {
                resourceListStore.reload = true
            }
        })

    onUnmounted(()=>{
        appUiStore.countRouteChange > 1 && resourceListStore.$reset()
    })
    
    return {
        messagesLoaded,
        asyncStatus,
        provider,
    }
}
